// extracted by mini-css-extract-plugin
module.exports = {"root":"CubeDescription-module__root__2I3JG","dim-popover-select":"CubeDescription-module__dim-popover-select__3gtRC","quick-tip":"CubeDescription-module__quick-tip__1aD0p"};